(function () {
  'use strict';

  /* ═══════════════════════════════════════════════════════
     TARASHE — Premium Scroll Engine v5
     v5 fix: drag-vs-click detection so <a> links navigate.
  ═══════════════════════════════════════════════════════ */

  var DRAG_THRESHOLD = 6;  /* px — must move more than this to be a "drag" */

  var PROFILES = {
    silk: {
      stiffness:0.072, damping:0.78, friction:0.92, flickMult:110,
      snapThreshold:0.08, minVel:0.03, snapDist:1.2,
      wheelMult:1.1, wheelDelay:120, rubberBand:0.28
    },
    snap: {
      stiffness:0.18, damping:0.74, friction:0.86, flickMult:75,
      snapThreshold:0.12, minVel:0.04, snapDist:1.5,
      wheelMult:0.95, wheelDelay:90, rubberBand:0.22
    },
    crisp: {
      stiffness:0.28, damping:0.68, friction:0.80, flickMult:55,
      snapThreshold:0.15, minVel:0.06, snapDist:2,
      wheelMult:0.85, wheelDelay:70, rubberBand:0.18
    },
    elastic: {
      stiffness:0.14, damping:0.62, friction:0.88, flickMult:90,
      snapThreshold:0.10, minVel:0.03, snapDist:1,
      wheelMult:1.0, wheelDelay:100, rubberBand:0.35, overshoot:true
    },
    inertia: {
      stiffness:0.048, damping:0.86, friction:0.96, flickMult:160,
      snapThreshold:0.06, minVel:0.02, snapDist:0.8,
      wheelMult:1.4, wheelDelay:160, rubberBand:0.32
    },
    magnetic: {
      stiffness:0.22, damping:0.70, friction:0.82, flickMult:65,
      snapThreshold:0.18, minVel:0.05, snapDist:1.8,
      wheelMult:0.9, wheelDelay:75, rubberBand:0.20
    }
  };

  function clamp(v, lo, hi) { return v < lo ? lo : v > hi ? hi : v; }
  function getClientX(e) {
    return e.touches        ? e.touches[0].clientX
         : e.changedTouches ? e.changedTouches[0].clientX
         : e.clientX;
  }

  function initCarousel(ROOT) {
    if (!ROOT || ROOT._fcsInit) return;
    ROOT._fcsInit = true;

    var sectionId = ROOT.dataset.sectionId;
    var viewport  = ROOT.querySelector('.fcs-viewport');
    var track     = ROOT.querySelector('.fcs-track');
    var prevBtn   = ROOT.querySelector('#fcs-prev-'    + sectionId);
    var nextBtn   = ROOT.querySelector('#fcs-next-'    + sectionId);
    var fillEl    = ROOT.querySelector('#fcs-fill-'    + sectionId);
    var counterEl = ROOT.querySelector('#fcs-counter-' + sectionId);
    var tabs      = ROOT.querySelectorAll('.fcs-tab');
    if (!track || !viewport) return;

    var gap        = parseInt(ROOT.dataset.gap) || 16;
    var sortMode   = ROOT.dataset.sort          || 'position';
    var profileKey = ROOT.dataset.scrollProfile || 'silk';
    var P          = PROFILES[profileKey]       || PROFILES.silk;
    var restMode   = ROOT.dataset.restMode === 'free' ? 'free' : 'snap';

    /* physics */
    var px = 0, vx = 0, targetPx = 0;
    var rafId = null, lastTs = null;
    var freeCoast = false; /* true while coasting to a stop in "free" rest mode */

    /* input — drag detection state */
    var pointerDown    = false;
    var isPointer      = false;
    var pointerStartX  = 0;
    var pointerStartPx = 0;
    var isDragging     = false;   /* becomes true ONLY after movement > threshold */
    var samples        = [];
    var touchStartY    = 0;
    var touchDir       = null;
    var wheelTimer;

    var visibleCards = [];
    var perView      = 3;
    var currentIndex = 0;

    function cardW() {
      return visibleCards.length ? visibleCards[0].offsetWidth + gap : 100;
    }
    function maxPx() {
      if (!visibleCards.length) return 0;
      return Math.max(0, visibleCards.length * cardW() - gap - viewport.offsetWidth);
    }
    function sizeCards() {
      perView = (function () {
        var w = window.innerWidth;
        if (w <= 600)  return parseInt(ROOT.dataset.perViewMobile)  || 1;
        if (w <= 1024) return parseInt(ROOT.dataset.perViewTablet)  || 2;
        return parseInt(ROOT.dataset.perViewDesktop) || 3;
      })();
      var vw = viewport.offsetWidth;
      var cw = Math.floor(((vw - gap * (perView - 1)) / perView) * 100) / 100;
      visibleCards.forEach(function (c) {
        c.style.width = c.style.minWidth = c.style.maxWidth = cw + 'px';
      });
    }
    function snapToPx(p)    { var cw = cardW(); return clamp(Math.round(p / cw) * cw, 0, maxPx()); }
    function indexFromPx(p) { var cw = cardW(); return cw > 0 ? Math.round(p / cw) : 0; }

    function applyTransform(x) {
      track.style.transform = 'translate3d(' + (-x).toFixed(2) + 'px,0,0)';
    }

    function tick(ts) {
      if (lastTs === null) lastTs = ts;
      var dt = clamp(ts - lastTs, 1, 32);
      lastTs = ts;

      if (!pointerDown && freeCoast) {
        /* FREE rest mode: pure momentum decay, no forced target.
           Carries forward at flick speed, decelerates gradually,
           and stops wherever the velocity runs out (mid-card is OK). */
        var decay = Math.pow(P.friction, dt / 16);
        vx *= decay;
        px += vx * dt * 0.1;
        if (Math.abs(vx) < P.minVel) {
          vx = 0;
          px = clamp(px, 0, maxPx());
          applyTransform(px); updateUI();
          freeCoast = false; rafId = null; lastTs = null;
          return;
        }
      } else if (!pointerDown) {
        /* SNAP rest mode (default): spring-ease to the nearest card. */
        var dx     = targetPx - px;
        var spring = dx * P.stiffness;
        if (P.overshoot) vx = vx * P.damping + spring;
        else             vx = (vx + spring) * P.damping;
        px += vx * dt * 0.1;
        if (Math.abs(dx) < P.snapDist && Math.abs(vx) < P.minVel) {
          px = targetPx; vx = 0;
          applyTransform(px); updateUI();
          rafId = null; lastTs = null;
          return;
        }
      }
      if (!pointerDown) px = clamp(px, 0, maxPx());
      applyTransform(px); updateUI();
      rafId = requestAnimationFrame(tick);
    }
    function startRAF() { if (!rafId) { lastTs = null; rafId = requestAnimationFrame(tick); } }
    function stopRAF()  { if (rafId)  { cancelAnimationFrame(rafId); rafId = null; } }

    function scrollToIndex(idx, instant) {
      /* Explicit navigation (arrows/keyboard/tabs) always lands on a full card,
         regardless of restMode — only organic flicks/wheel respect "free". */
      var mx = Math.max(0, visibleCards.length - perView);
      idx = clamp(idx, 0, mx);
      currentIndex = idx;
      freeCoast = false;
      targetPx = clamp(idx * cardW(), 0, maxPx());
      if (instant) { stopRAF(); px = targetPx; vx = 0; applyTransform(px); updateUI(); }
      else         { vx = 0; startRAF(); }
    }

    function updateUI() {
      var mx  = maxPx();
      var pct = mx > 0 ? (px / mx) * 100 : 100;
      if (fillEl) fillEl.style.width = clamp(pct, 0, 100).toFixed(1) + '%';
      var idx = indexFromPx(px), tot = visibleCards.length;
      if (counterEl) counterEl.textContent = Math.min(idx + 1, tot) + ' / ' + tot;
      currentIndex = idx;
      var atStart = px <= 1, atEnd = px >= mx - 1;
      if (prevBtn) { prevBtn.disabled = atStart; prevBtn.style.opacity = atStart ? '0.28' : '1'; }
      if (nextBtn) { nextBtn.disabled = atEnd;   nextBtn.style.opacity = atEnd   ? '0.28' : '1'; }
    }

    function recordSample(x) {
      var now = performance.now();
      samples.push({ x: x, t: now });
      while (samples.length > 1 && now - samples[0].t > 80) samples.shift();
    }
    function getVelocity() {
      if (samples.length < 2) return 0;
      var a = samples[0], b = samples[samples.length - 1];
      var dt = b.t - a.t;
      return dt > 0 ? (b.x - a.x) / dt : 0;
    }
    function rubberClamp(p) {
      var mx = maxPx();
      if (p < 0)  return p * P.rubberBand;
      if (p > mx) return mx + (p - mx) * P.rubberBand;
      return p;
    }

    /* ── Pointer down — do NOT preventDefault yet.
       Wait to see if the user actually drags. */
    function onDown(e) {
      if (e.type === 'mousedown' && e.button !== 0) return;
      pointerDown    = true;
      isPointer      = e.type === 'mousedown';
      pointerStartX  = getClientX(e);
      pointerStartPx = px;
      isDragging     = false;
      freeCoast      = false;
      samples        = [{ x: pointerStartX, t: performance.now() }];
      vx             = 0;
      stopRAF(); lastTs = null;
      track.style.willChange = 'transform';
      /* removed: e.preventDefault() — was killing link clicks */
    }

    /* ── Pointer move — only start dragging after threshold */
    function onMove(e) {
      if (!pointerDown) return;
      var cx     = getClientX(e);
      var dx     = Math.abs(cx - pointerStartX);

      /* Not dragging yet — wait for threshold */
      if (!isDragging) {
        if (dx <= DRAG_THRESHOLD) return;
        isDragging = true;
        if (isPointer) track.classList.add('is-dragging');
      }

      recordSample(cx);
      var raw = pointerStartPx - (cx - pointerStartX);
      px = rubberClamp(raw);
      applyTransform(px);
      updateUI();

      /* Only preventDefault once we KNOW it's a drag — preserves link clicks */
      if (e.cancelable) e.preventDefault();
    }

    /* ── Pointer up — if no drag happened, let the click fire naturally */
    function onUp(e) {
      if (!pointerDown) return;
      pointerDown = false;
      track.style.willChange = '';

      if (!isDragging) {
        /* Pure click — DON'T snap, DON'T preventDefault. Link will navigate. */
        track.classList.remove('is-dragging');
        return;
      }

      /* It was a drag — run momentum as before, branched by restMode */
      track.classList.remove('is-dragging');
      var vel   = getVelocity();
      var speed = Math.abs(vel);
      var mx    = maxPx();

      if (restMode === 'free') {
        /* FREE: carry the flick's actual velocity and let it decay naturally.
           No forced target — it can glide through several cards and stop
           anywhere, including mid-card. */
        freeCoast = true;
        vx = clamp(-vel * P.flickMult, -P.flickMult * 1.2, P.flickMult * 1.2);
        currentIndex = indexFromPx(px);
        startRAF();
        return;
      }

      /* SNAP (default): project forward by flick speed, then lock to the
         nearest full card and ease into it. */
      var projected;
      if (speed > 0.15) {
        projected = px - vel * P.flickMult * P.friction;
        targetPx  = snapToPx(clamp(projected, 0, mx));
      } else {
        targetPx  = snapToPx(clamp(px, 0, mx));
      }
      vx = -vel * (P.overshoot ? 8 : 5);
      currentIndex = indexFromPx(targetPx);
      startRAF();
    }

    /* ── Capture-phase click guard: block clicks only if a drag happened */
    track.addEventListener('click', function (e) {
      if (isDragging) {
        e.preventDefault();
        e.stopPropagation();
        isDragging = false;
      }
    }, true);

    /* Mouse */
    track.addEventListener('mousedown', onDown);
    document.addEventListener('mousemove', function (e) {
      if (!pointerDown || !isPointer) return;
      onMove(e);
    });
    document.addEventListener('mouseup', function (e) {
      if (pointerDown && isPointer) onUp(e);
    });

    /* Touch */
    track.addEventListener('touchstart', function (e) {
      touchStartY = e.touches[0].clientY;
      touchDir    = null;
      onDown(e);
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      if (!pointerDown) return;
      if (touchDir === null) {
        var dx = Math.abs(getClientX(e) - pointerStartX);
        var dy = Math.abs(e.touches[0].clientY - touchStartY);
        if (dx < 5 && dy < 5) return;
        touchDir = dx >= dy ? 'h' : 'v';
      }
      if (touchDir === 'v') {
        pointerDown = false;
        isDragging  = false;
        freeCoast   = false;
        targetPx = snapToPx(px);
        vx = 0; startRAF();
        return;
      }
      onMove(e);
    }, { passive: false });

    track.addEventListener('touchend',    onUp, { passive: true });
    track.addEventListener('touchcancel', onUp, { passive: true });

    /* Wheel */
    viewport.addEventListener('wheel', function (e) {
      var horiz = Math.abs(e.deltaX) > Math.abs(e.deltaY);
      var shift = e.shiftKey;
      if (!horiz && !shift) return;
      e.preventDefault();
      var delta = horiz ? e.deltaX : e.deltaY;
      if (e.deltaMode === 1) delta *= 30;
      if (e.deltaMode === 2) delta *= viewport.offsetWidth;
      stopRAF(); vx = 0; freeCoast = false;
      px = clamp(px + delta * P.wheelMult * 0.9, 0, maxPx());
      applyTransform(px); updateUI();
      clearTimeout(wheelTimer);
      wheelTimer = setTimeout(function () {
        if (restMode === 'free') {
          /* FREE: leave it wherever the wheel left it — no forced snap. */
          return;
        }
        targetPx = snapToPx(px);
        startRAF();
      }, P.wheelDelay);
    }, { passive: false });

    /* Keyboard */
    viewport.addEventListener('keydown', function (e) {
      var handled = true;
      if      (e.key === 'ArrowLeft')  scrollToIndex(currentIndex - 1);
      else if (e.key === 'ArrowRight') scrollToIndex(currentIndex + 1);
      else if (e.key === 'Home')       scrollToIndex(0);
      else if (e.key === 'End')        scrollToIndex(visibleCards.length - 1);
      else handled = false;
      if (handled) e.preventDefault();
    });

    /* Arrow buttons */
    if (prevBtn) prevBtn.addEventListener('click', function () { scrollToIndex(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollToIndex(currentIndex + 1); });

    /* Sort + filter (unchanged from v4) */
    function sortCards(arr, mode) {
      arr = arr.slice();
      var m = {
        position:       function (a, b) { return +a.dataset.position - +b.dataset.position; },
        new_first:      function (a, b) { return +b.dataset.date     - +a.dataset.date; },
        price_asc:      function (a, b) { return +a.dataset.price    - +b.dataset.price; },
        price_desc:     function (a, b) { return +b.dataset.price    - +a.dataset.price; },
        new_tag_first:  function (a, b) { return (b.dataset.new==='true'?1:0)-(a.dataset.new==='true'?1:0); },
        available_first:function (a, b) { return (b.dataset.available==='true'?1:0)-(a.dataset.available==='true'?1:0); }
      };
      if (m[mode]) { arr.sort(m[mode]); return arr; }
      if (mode === 'random') {
        for (var i = arr.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var t = arr[i]; arr[i] = arr[j]; arr[j] = t;
        }
        return arr;
      }
      if (mode === 'interleave') {
        var groups = {}, keys = [];
        arr.forEach(function (c) {
          var k = c.dataset.collection || 'x';
          if (!groups[k]) { groups[k] = []; keys.push(k); }
          groups[k].push(c);
        });
        var res = [], maxL = 0;
        keys.forEach(function (k) { if (groups[k].length > maxL) maxL = groups[k].length; });
        for (var i = 0; i < maxL; i++) keys.forEach(function (k) { if (groups[k][i]) res.push(groups[k][i]); });
        return res;
      }
      return arr;
    }
    function applySort(mode) {
      var sorted = sortCards(Array.from(track.querySelectorAll('.fcs-card')), mode);
      sorted.forEach(function (c) { track.appendChild(c); });
      applyFilter(activeFilter, true);
    }
    var activeFilter = 'all';
    function applyFilter(handle, instant) {
      activeFilter = handle;
      visibleCards = [];
      Array.from(track.querySelectorAll('.fcs-card')).forEach(function (c) {
        var show = handle === 'all' || c.dataset.collection === handle;
        c.style.display = show ? '' : 'none';
        if (show) visibleCards.push(c);
      });
      sizeCards();
      scrollToIndex(0, instant);
    }
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('fcs-tab--active'); t.setAttribute('aria-selected','false'); });
        tab.classList.add('fcs-tab--active');
        tab.setAttribute('aria-selected','true');
        applyFilter(tab.dataset.filter, false);
      });
    });

    /* Quick add / wishlist — these run only when the click guard above lets them through */
    track.addEventListener('click', function (e) {
      var btn = e.target.closest('.fcs-btn-add[data-variant-id]');
      if (btn) {
        e.preventDefault();
        var lbl = btn.querySelector('.fcs-btn-label');
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: btn.dataset.variantId, quantity: 1 })
        })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (lbl) lbl.textContent = '✓ Added';
          btn.classList.add('fcs-btn-add--done');
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(function () {
            btn.classList.remove('fcs-btn-add--done');
            if (lbl) lbl.textContent = btn.dataset.defaultLabel || 'Add to Cart';
            btn.disabled = false;
          }, 2200);
        })
        .catch(function () { btn.disabled = false; });
        return;
      }
      var wl = e.target.closest('.fcs-wishlist-btn');
      if (wl) {
        e.preventDefault();
        var on = wl.getAttribute('aria-pressed') === 'true';
        wl.setAttribute('aria-pressed', String(!on));
        wl.classList.toggle('fcs-wishlist-btn--active', !on);
        var path = wl.querySelector('path');
        if (path) path.setAttribute('fill', !on ? 'currentColor' : 'none');
      }
    });

    /* Resize */
    var resizeTimer;
    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () { sizeCards(); scrollToIndex(0, true); }, 60);
      }).observe(viewport);
    } else {
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () { sizeCards(); scrollToIndex(0, true); }, 120);
      });
    }

    track.style.transition = 'none';
    applySort(sortMode);
  }

  function boot() {
    document.querySelectorAll('.fcs-section').forEach(initCarousel);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.fcs-section');
    if (s) { s._fcsInit = false; initCarousel(s); }
  });

})();